import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/haeufigkeiten/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="Frequencies"
      returnRoute="/auswahlfelder/frequencies"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const FrequenciesRoute = Route;
